import React from 'react'
import AppBar from '../components/AppBar'
import BoxSystem from '../components/NameCards'
import Footer from '../components/Footer';

function About() {
  return (
    <div>
      <AppBar></AppBar>
      <BoxSystem></BoxSystem>
      <Footer/>
    </div>
  )
}

export default About
